// extracted by mini-css-extract-plugin
module.exports = {"form":"ContactsForm_form__3MDAp","label":"ContactsForm_label__30v9W","input":"ContactsForm_input__3yLW5","btn":"ContactsForm_btn__2Y3fg"};